/* eslint-disable */
import {
  GET_PROMOTION_INFO_SUCCESS,
  GET_PROMOTION_INFO_START,
  GET_PROMOTION_INFO_FAIL,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_START,
  GET_PARTNERS_FAIL,
  GET_PROMOTIONS_SUCCESS,
  GET_PROMOTIONS_FAIL,
  GET_PROMOTIONS_START,
  GET_PARTNER_INFO_START,
  GET_PARTNER_INFO_SUCCESS,
  GET_PARTNER_INFO_FAIL,
  GET_PROMOCODES_SUCCESS,
  GET_PROMOCODES_FAIL,
  GET_PROMOCODES_START,
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_SUCCESS,
  GET_SUBSCRIBERS_LIST_FAIL,
  POST_CREATE_PARTNER_START,
  POST_CREATE_PARTNER_SUCCESS,
  POST_CREATE_PARTNER_FAIL,
  GET_PARTNERS_LIST_START,
  GET_PARTNERS_LIST_SUCCESS,
  GET_PARTNERS_LIST_FAIL,
  GET_CITIES_START,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAIL,
  UPDATE_PARTNER_START,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAIL,
  GET_CMS_START,
  GET_CMS_SUCCESS,
  GET_CMS_FAIL,
  CREATE_PROMOTION_START,
  CREATE_PROMOTION_SUCCESS,
  CREATE_PROMOTION_FAIL,
  UPDATE_PROMOTION_START,
  UPDATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION_FAIL,
  DELETE_PROMO_FILE_START,
  DELETE_PROMO_FILE_SUCCESS,
  DELETE_PROMO_FILE_FAIL,
  UPLOAD_PROMO_FILE_START,
  UPLOAD_PROMO_FILE_SUCCESS,
  UPLOAD_PROMO_FILE_FAIL,
  DELETE_CUSTOMER_FILE_START,
  DELETE_CUSTOMER_FILE_SUCCESS,
  DELETE_CUSTOMER_FILE_FAIL,
  UPLOAD_CUSTOMER_FILE_START,
  UPLOAD_CUSTOMER_FILE_SUCCESS,
  UPLOAD_CUSTOMER_FILE_FAIL,
  GET_PROMO_FILES_START,
  GET_PROMO_FILES_FAIL,
  GET_PROMO_FILES_SUCCESS,
  GET_CUSTOMER_FILE_START,
  GET_CUSTOMER_FILE_SUCCESS,
  GET_CUSTOMER_FILE_FAIL,
  GET_CUSTOMER_FILES_START,
  GET_CUSTOMER_FILES_SUCCESS,
  GET_CUSTOMER_FILES_FAIL,
  ARCHIVE_PROMOTION_START,
  ARCHIVE_PROMOTION_SUCCESS,
  ARCHIVE_PROMOTION_FAIL,
  ARCHIVE_PARTNER_START,
  ARCHIVE_PARTNER_SUCCESS,
  ARCHIVE_PARTNER_FAIL,
  GET_PROMO_CODES_START,
  GET_PROMO_CODES_SUCCESS,
  GET_PROMO_CODES_FAIL,
  UNARCHIVE_PARTNER_START,
  UNARCHIVE_PARTNER_SUCCESS,
  UNARCHIVE_PARTNER_FAIL,
  UPDATE_PARTNERS_POSITIONS_START,
  UPDATE_PARTNERS_POSITIONS_SUCCESS,
  UPDATE_PARTNERS_POSITIONS_FAIL,
  UPDATE_PROMOTIONS_POSITIONS_START,
  UPDATE_PROMOTIONS_POSITIONS_SUCCESS,
  UPDATE_PROMOTIONS_POSITIONS_FAIL
} from './constants';

import { action } from '../action';
import {
  requestCreatePartner,
  requestGetCities,
  requestGetPartners,
  requestUpdatePartner,
  requestGetPartner,
  requestGetPromotions,
  requestGetPartnersList,
  requestGetPromotion,
  requestGetPackages,
  requestCreatePromotion,
  requestUpdatePromotion,
  requestUploadPromoCodeFileId,
  requestUploadPromoCodeFile,
  requestUploadPartnerFile,
  requestUploadFile,
  requestDeletePartnerFile,
  requestDeletePromoCodeFile,
  requestGetPromoFiles,
  requestGetCustomerFiles,
  requestGetCustomerFile,
  requestArchivePartner,
  requestArchivePromotion,
  requestGetPromoCodes,
  requestUnarchivePartner,
  requestCopyPromotion,
  requestUpdatePartnersPositions,
  requestUpdatePromotionsPositions
} from '../../api/partners';

export const actionPartners = action(GET_PARTNERS_START, GET_PARTNERS_SUCCESS, GET_PARTNERS_FAIL);
export const getPartners = (payload) => async (dispatch) => {
  try {
    dispatch(actionPartners.start());
    const data = await requestGetPartners(payload);
    dispatch(actionPartners.success(data));
  } catch (error) {
    dispatch(actionPartners.fail(error.detail));
  }
};

export const actionCities = action(GET_CITIES_START, GET_CITIES_SUCCESS, GET_CITIES_FAIL);
export const getCities = (payload) => async (dispatch) => {
  try {
    dispatch(actionCities.start());
    const data = await requestGetCities(payload);
    dispatch(actionCities.success(data.data));
    return data;
  } catch (error) {
    dispatch(actionCities.fail(error.detail));
  }
};

export const actionPromotions = action(
  GET_PROMOTIONS_START,
  GET_PROMOTIONS_SUCCESS,
  GET_PROMOTIONS_FAIL
);
export const getPromotions = (payload) => async (dispatch) => {
  try {
    dispatch(actionPromotions.start());
    const data = await requestGetPromotions(payload);
    dispatch(actionPromotions.success(data));
  } catch (error) {
    dispatch(actionPromotions.fail(error.detail));
  }
};

export const actionEvent = action(
  GET_PROMOTION_INFO_START,
  GET_PROMOTION_INFO_SUCCESS,
  GET_PROMOTION_INFO_FAIL
);
export const getPromotionById = (id) => async (dispatch) => {
  try {
    dispatch(actionEvent.start());
    const data = await requestGetPromotion(id);
    dispatch(actionEvent.success(data));
  } catch (error) {
    dispatch(actionEvent.fail(error.detail));
  }
};

export const actionCopyPromotion = action(
  GET_PROMOTION_INFO_START,
  GET_PROMOTION_INFO_SUCCESS,
  GET_PROMOTION_INFO_FAIL
);
export const copyPromotion = (id) => async (dispatch) => {
  try {
    dispatch(actionCopyPromotion.start());
    const data = await requestCopyPromotion(id);
    dispatch(actionCopyPromotion.success(data));
  } catch (error) {
    dispatch(actionCopyPromotion.fail(error.detail));
  }
};

export const actionPartner = action(
  GET_PARTNER_INFO_START,
  GET_PARTNER_INFO_SUCCESS,
  GET_PARTNER_INFO_FAIL
);
export const getPartnerById = (id) => async (dispatch) => {
  try {
    dispatch(actionPartner.start());
    const data = await requestGetPartner(id);
    dispatch(actionPartner.success(data));
  } catch (error) {
    dispatch(actionPartner.fail(error.detail));
  }
};

export const actionPromocodes = action(
  GET_PROMOCODES_START,
  GET_PROMOCODES_SUCCESS,
  GET_PROMOCODES_FAIL
);
export const getPromocodes = () => async (dispatch) => {
  try {
    dispatch(actionPromocodes.start());
    dispatch(
      actionPromocodes.success({
        items: [],
        total: 0
      })
    );
  } catch (error) {
    dispatch(actionPromocodes.fail(error.detail));
  }
};

export const actionSubscribers = action(
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_SUCCESS,
  GET_SUBSCRIBERS_LIST_FAIL
);
export const getSubscribersList = () => async (dispatch) => {
  try {
    dispatch(actionSubscribers.start());
    dispatch(
      actionSubscribers.success({
        items: [],
        total: 0
      })
    );
  } catch (error) {
    dispatch(actionSubscribers.fail(error.detail));
  }
};

export const actionsGetPartnersList = action(
  GET_PARTNERS_LIST_START,
  GET_PARTNERS_LIST_SUCCESS,
  GET_PARTNERS_LIST_FAIL
);
export const getPartnersList = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetPartnersList.start());
    const data = await requestGetPartnersList(payload);
    dispatch(actionsGetPartnersList.success(data));
  } catch (error) {
    dispatch(actionsGetPartnersList.fail(error.detail));
  }
};

export const actionsCreatePartner = action(
  POST_CREATE_PARTNER_START,
  POST_CREATE_PARTNER_SUCCESS,
  POST_CREATE_PARTNER_FAIL
);
export const postCreatePartner = (payload, redirect) => async (dispatch) => {
  try {
    dispatch(actionsCreatePartner.start());
    const data = await requestCreatePartner(payload);
    dispatch(actionsCreatePartner.success(data));
    redirect && redirect();
  } catch (error) {
    dispatch(actionsCreatePartner.fail(error.response.data.detail));
  }
};

export const actionsUpdatePartner = action(
  UPDATE_PARTNER_START,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAIL
);
export const updatePartner = (id, payload, redirect) => async (dispatch) => {
  try {
    dispatch(actionsUpdatePartner.start());
    const data = await requestUpdatePartner(id, payload);
    dispatch(actionsUpdatePartner.success(data));
    redirect && redirect();
  } catch (error) {
    dispatch(actionsUpdatePartner.fail(error.response.data.detail));
  }
};

export const actionsCreatePromotion = action(
  CREATE_PROMOTION_START,
  CREATE_PROMOTION_SUCCESS,
  CREATE_PROMOTION_FAIL
);
export const createPromotion = (payload) => async (dispatch) => {
  try {
    dispatch(actionsCreatePromotion.start());
    const data = await requestCreatePromotion(payload);
    dispatch(actionsCreatePromotion.success(data));
    return data;
  } catch (error) {
    dispatch(actionsCreatePromotion.fail(error?.response?.data?.detail));
  }
};

export const actionsUpdatePromotion = action(
  UPDATE_PROMOTION_START,
  UPDATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION_FAIL
);
export const updatePromotion = (id, payload, redirect) => async (dispatch) => {
  try {
    dispatch(actionsUpdatePromotion.start());
    const data = await requestUpdatePromotion(id, payload);
    dispatch(actionsUpdatePromotion.success(data));
    redirect && redirect();
  } catch (error) {
    dispatch(actionsUpdatePromotion.fail(error?.response?.data?.detail));
  }
};

export const actionCMS = action(GET_CMS_START, GET_CMS_SUCCESS, GET_CMS_FAIL);
export const getCMS = (payload) => async (dispatch) => {
  try {
    dispatch(actionCMS.start());
    const data = await requestGetPackages(payload);
    dispatch(actionCMS.success(data.data));
    return data;
  } catch (error) {
    dispatch(actionCMS.fail(error.detail));
  }
};

export const actionsUploadCustomerFiles = action(
  UPLOAD_CUSTOMER_FILE_START,
  UPLOAD_CUSTOMER_FILE_SUCCESS,
  UPLOAD_CUSTOMER_FILE_FAIL
);
export const uploadCustomerFiles = (payload, id) => async (dispatch) => {
  try {
    dispatch(actionsUploadCustomerFiles.start());
    let data;
    if (id) data = await requestUploadPartnerFile(payload, id);
    else data = await requestUploadFile(payload);
    dispatch(actionsUploadCustomerFiles.success(data));
    return data;
  } catch (error) {
    dispatch(actionsUploadCustomerFiles.fail(error.detail));
    return error.response;
  }
};

export const actionsDeleteCustomerFiles = action(
  DELETE_CUSTOMER_FILE_START,
  DELETE_CUSTOMER_FILE_SUCCESS,
  DELETE_CUSTOMER_FILE_FAIL
);
export const deleteCustomerFiles = (id, file_id) => async (dispatch) => {
  try {
    dispatch(actionsDeleteCustomerFiles.start());
    const data = await requestDeletePartnerFile(id, file_id);
    dispatch(actionsDeleteCustomerFiles.success(file_id));
    return data;
  } catch (error) {
    dispatch(actionsDeleteCustomerFiles.fail(error.response.data));
    return error.response;
  }
};

export const actionsUploadPromoFiles = action(
  UPLOAD_PROMO_FILE_START,
  UPLOAD_PROMO_FILE_SUCCESS,
  UPLOAD_PROMO_FILE_FAIL
);
export const uploadPromoFiles = (payload, id) => async (dispatch) => {
  try {
    dispatch(actionsUploadPromoFiles.start());
    let data;
    if (id) data = await requestUploadPromoCodeFileId(payload, id);
    else data = await requestUploadPromoCodeFile(payload);
    dispatch(actionsUploadPromoFiles.success(data));
    return data;
  } catch (error) {
    dispatch(actionsUploadPromoFiles.fail(error.detail));
    return error.response;
  }
};

export const actionsDeletePromoFiles = action(
  DELETE_PROMO_FILE_START,
  DELETE_PROMO_FILE_SUCCESS,
  DELETE_PROMO_FILE_FAIL
);
export const deletePromoFiles = (id, file_id) => async (dispatch) => {
  try {
    dispatch(actionsDeletePromoFiles.start());
    const data = await requestDeletePromoCodeFile(id, file_id);
    dispatch(actionsDeletePromoFiles.success(file_id));
    return data;
  } catch (error) {
    dispatch(actionsDeletePromoFiles.fail(error?.response?.data.detail));
    return error.response;
  }
};

export const actionsPromoFiles = action(
  GET_PROMO_FILES_START,
  GET_PROMO_FILES_SUCCESS,
  GET_PROMO_FILES_FAIL
);
export const getPromoFiles = (id) => async (dispatch) => {
  try {
    dispatch(actionsPromoFiles.start());
    const data = await requestGetPromoFiles(id);
    dispatch(actionsPromoFiles.success(data));
  } catch (error) {
    dispatch(actionsPromoFiles.fail(error?.response?.data.detail));
    return error.response;
  }
};

export const actionsCustomerFiles = action(
  GET_CUSTOMER_FILES_START,
  GET_CUSTOMER_FILES_SUCCESS,
  GET_CUSTOMER_FILES_FAIL
);
export const getCustomerFiles = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsCustomerFiles.start());
    const data = await requestGetCustomerFiles(id, payload);
    dispatch(actionsCustomerFiles.success(data));
  } catch (error) {
    dispatch(actionsCustomerFiles.fail(error?.response));
    return error.response;
  }
};

export const actionsPromoCodes = action(
  GET_PROMO_CODES_START,
  GET_PROMO_CODES_SUCCESS,
  GET_PROMO_CODES_FAIL
);
export const getPromoCodes = (payload) => async (dispatch) => {
  try {
    dispatch(actionsPromoCodes.start());
    const data = await requestGetPromoCodes(payload);
    dispatch(actionsPromoCodes.success(data));
  } catch (error) {
    dispatch(actionsPromoCodes.fail(error?.response));
  }
};

export const actionsCustomerFile = action(
  GET_CUSTOMER_FILE_START,
  GET_CUSTOMER_FILE_SUCCESS,
  GET_CUSTOMER_FILE_FAIL
);
export const getCustomerFile = (id) => async (dispatch) => {
  try {
    dispatch(actionsCustomerFile.start());
    const data = await requestGetCustomerFile(id);
    dispatch(actionsCustomerFile.success(data));
  } catch (error) {
    dispatch(actionsCustomerFile.fail(error?.response?.data.detail));
    return error.response;
  }
};

export const actionsArchivePartner = action(
  ARCHIVE_PARTNER_START,
  ARCHIVE_PARTNER_SUCCESS,
  ARCHIVE_PARTNER_FAIL
);
export const archivePartner = (id) => async (dispatch) => {
  try {
    dispatch(actionsArchivePartner.start());
    await requestArchivePartner(id);
    dispatch(actionsArchivePartner.success(id));
  } catch (error) {
    dispatch(actionsArchivePartner.fail(error?.response?.data.detail));
  }
};

export const actionsUnarchivePartner = action(
  UNARCHIVE_PARTNER_START,
  UNARCHIVE_PARTNER_SUCCESS,
  UNARCHIVE_PARTNER_FAIL
);
export const unarchivePartner = (id) => async (dispatch) => {
  try {
    dispatch(actionsUnarchivePartner.start());
    await requestUnarchivePartner(id);
    dispatch(actionsUnarchivePartner.success(id));
  } catch (error) {
    dispatch(actionsUnarchivePartner.fail(error?.response?.data.detail));
  }
};

export const actionsArchivePromotion = action(
  ARCHIVE_PROMOTION_START,
  ARCHIVE_PROMOTION_SUCCESS,
  ARCHIVE_PROMOTION_FAIL
);
export const archivePromotion = (id) => async (dispatch) => {
  try {
    dispatch(actionsArchivePromotion.start());
    const data = await requestArchivePromotion(id);
    dispatch(actionsArchivePromotion.success(id));
  } catch (error) {
    dispatch(actionsArchivePromotion.fail(error?.response?.data.detail));
  }
};

export const actionsUpdatePartnersPositions = action(
  UPDATE_PARTNERS_POSITIONS_START,
  UPDATE_PARTNERS_POSITIONS_SUCCESS,
  UPDATE_PARTNERS_POSITIONS_FAIL
);

export const updatePartnersPositions = (positions) => async (dispatch) => {
  try {
    dispatch(actionsUpdatePartnersPositions.start());
    const data = await requestUpdatePartnersPositions({ positions: positions.map((item) => item.id)});
    dispatch(actionsUpdatePartnersPositions.success(positions));
  } catch (error) {
    dispatch(actionsUpdatePartnersPositions.fail(error?.response?.data.detail));
  }
};

export const actionsUpdatePromotionsPositions = action(
  UPDATE_PROMOTIONS_POSITIONS_START,
  UPDATE_PROMOTIONS_POSITIONS_SUCCESS,
  UPDATE_PROMOTIONS_POSITIONS_FAIL
);
export const updatePromotionsPositions = (positions) => async (dispatch) => {
  try {
    dispatch(actionsUpdatePromotionsPositions.start());
    const data = await requestUpdatePromotionsPositions({ positions: positions.map((item) => item.id)});
    dispatch(actionsUpdatePromotionsPositions.success(positions));
  } catch (error) {
    dispatch(actionsUpdatePromotionsPositions.fail(error?.response?.data.detail));
  }
};